// extracted by mini-css-extract-plugin
export default {"btn_submit":"SplitCard_btn_submit__SNBOb","titlePC":"SplitCard_titlePC__q-JXU","titleMB":"SplitCard_titleMB__r+feB"};